import React, { useEffect, useState } from 'react'
import Service from '../Networking/NetworkingUtils';
import { useSnackbar } from 'notistack';
import { getCookie } from '../Utils/CookieHelper';
import { Box, Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AccessLink from './AccessLink';
import AddBoxIcon from '@mui/icons-material/AddBox';


var token = getCookie("bb_metaverse_token");
var user = JSON.parse(getCookie("bb_metaverse_user"));


const AccessGroup = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [accessLoading, setAccessLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const [rowData, setRowData] = useState({})
    const [dialogOpen, setDialogopen] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [accessData, setAccessData] = useState([])
    const [access, setAccess] = useState([])
    const [linkedData, setLinkedData] = useState({})
    const [columns] = useState([
        { title: 'Name', field: 'name' },
        { title: 'Description', field: 'description' },
        { title: 'Date Created', field: 'date_created', render: rowData => new Date(rowData.date_created).toLocaleDateString() },
    ])
    const [addData, setAddData] = useState({
        name: '',
        description: ''
    })


    const getData = () => {
        Service.get(`/api/access/group/get_access_group_data/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data
        })
            .then(res => {
                setData(res.data)
                setLoading(false)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    const getAccess = (row) => {
        setAccessLoading(true)
        Service.get(`/api/access/group/link/get_group_access_data/?access_group=${row.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let data = {}
                data.left = access.filter(item => !res.data.linked_access.some(linked => linked.id === item.id))
                data.right = res.data.linked_access
                setAccessData(data)
                setLinkedData(res.data)
                setAccessLoading(false)

            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    const getAccessManagement = (row) => {
        Service.get(`/api/access/management/get_access_data/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                setAccess(res.data)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }


    useEffect(() => {
        getData()
        getAccessManagement()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAccessLink = (leftChecked) => {
        Service.post(`/api/access/group/link/create_access_group_link/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: leftChecked[0]
        })
            .then(res => {
                enqueueSnackbar('Model edited Successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    const handleAccessLinkAndDelink = (data, action) => {
        let access = []
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            access.push(element.id)
        }
        let requestData = {
            'access_group': linkedData.access_group.id,
            'access_ids': access,
            'action': action
        }
        Service.post(`/api/access/group/link/link_and_delink_group_access/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: requestData
        })
            .then(res => {
                enqueueSnackbar('Changes Saved!', {
                    variant: 'success'
                });
            })
            .catch(error => {
                console.log(error)
                if (error.status === 406) {
                    enqueueSnackbar(error.data, {
                        variant: 'warning'
                    });
                    return
                } else {
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                    return
                }
            });
    }


    const handleRowClick = (row) => {
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if (element.id === row.id) {
                data[index].isOpen = !row.isOpen
            } else {
                data[index].isOpen = false
            }
        }
        setOpen(!open)
        if (row.isOpen) {
            getAccess(row)
        }
    }

    const addAccessGroup = () => {
        if (addData.name.length === 0) {
            enqueueSnackbar('Name is required!', {
                variant: 'warning'
            });
            return
        }
        if (addData.description.length === 0) {
            enqueueSnackbar('Description is required!', {
                variant: 'warning'
            });
            return
        }
        addData.date_created = new Date()
        addData.created_by = user.id
        Service.post(`/api/access/group/create_access_group/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: addData
        })
            .then(res => {
                setDialogopen(false)
                getData()
                enqueueSnackbar('Model added Successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    const editAccessGroup = () => {
    }


    return (
        <div>
            {loading ? <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box> :
                <TableContainer component={Paper}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' padding={1}>
                        <Typography variant="h5">Group Access</Typography>
                        <Box>
                            <Button onClick={() => { setDialogopen(true); setIsEdit(false); }}><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button>
                        </Box>
                    </Box>
                    <React.Fragment>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                    <TableCell />
                                    {columns && columns.map((column) => (
                                        <TableCell key={column.field}>{column.title}</TableCell>
                                    ))}
                                    {/* <TableCell>
                                        Actions
                                    </TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data && data.map((row) => (
                                    <React.Fragment key={row.id}>
                                        <TableRow onClick={() => { setRowData(row) }} sx={{ cursor: 'pointer' }}>
                                            <TableCell>
                                                <IconButton aria-label="expand row" size="small" onClick={() => { handleRowClick(row) }}>
                                                    {row.isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                </IconButton>
                                            </TableCell>
                                            {columns && columns.map((column) => (
                                                <TableCell key={column.field}  >
                                                    {column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                                </TableCell>
                                            ))}
                                            {/* <TableCell> */}
                                            {/* <Tooltip title="Edit"> */}
                                            {/* <IconButton onClick={(e) => { e.stopPropagation(); setDialogopen(true); setEditObj(row); setIsEdit(true) }}><EditIcon /></IconButton> */}
                                            {/* </Tooltip> */}
                                            {/* </TableCell> */}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                <Collapse in={row.isOpen} timeout="auto" unmountOnExit>
                                                    {row.isOpen ?
                                                        accessLoading ? <Box display="flex" width='100%' justifyContent="center" alignItems="center">
                                                            <CircularProgress />
                                                        </Box> :
                                                            <Box sx={{ margin: 1 }}>
                                                                <AccessLink rowData={rowData} value={accessData} stage={'l0a'} AccessLink={handleAccessLink} AccessLinkAndDelink={handleAccessLinkAndDelink} />
                                                            </Box>
                                                        : null}
                                                </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </React.Fragment>
                </TableContainer>}
            <Dialog open={dialogOpen} onClose={() => setDialogopen(false)} maxWidth='xs' fullWidth>
                <DialogTitle>{isEdit ? "Edit Access Group" : "Add Access Group"}</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={addData.name}
                        onChange={(e) => setAddData({ ...addData, name: e.target.value })}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Description"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={addData.description}
                        onChange={(e) => setAddData({ ...addData, description: e.target.value })}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogopen(false)}>Cancel</Button>
                    <Button onClick={() => { isEdit ? editAccessGroup() : addAccessGroup() }} variant="contained">{isEdit ? "Save" : "Add"}</Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default AccessGroup